import React from 'react';
import { Input, InputNumber } from '@roo/roo';
import styled from 'styled-components';
import { FieldX } from './fieldx';
import { OrgKs } from '../../_utils/config';

const OrgDiv = styled.div`
  .org-type-form {
    margin-top: 24px;
  }
  .alien-right {
    label {
      text-align: left;
    }
  }

  .info {
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    line-height: 14px;
    text-align: left;
    margin-bottom: 24px;
    i {
      margin-right: 4px;
      position: relative;
      top: -1px;
    }
  }
  .prefix-w {
    ::after {
      content: '万元';
      position: relative;
      right: 24px;
    }
  }
`;
// 经营信息
export const Business = function (props) {
  const { values, orgType, idx } = props;
  return (
    <OrgDiv className={'form-patch'}>
      <FieldX
        label={'主营业务'}
        name={`baseInfo.${idx}.mainBusiness`}
        as={<Input.Textarea placeholder={'请输入200字以内说明'} maxLength={200} />}
        orgType={orgType}
      />
      <p className='desc'>{values.mainBusiness.length}/200</p>
      <br />
      <FieldX
        name={`baseInfo.${idx}.${OrgKs.businessScope}`}
        as={<Input.Textarea placeholder={'请输入200字以内说明'} maxLength={200} />}
        orgType={orgType}
      />
      <p className='desc'>{values.businessScope.length}/200</p>
      <br />
      <FieldX
        name={`baseInfo.${idx}.${OrgKs.organizationAbstract}`}
        as={<Input.Textarea placeholder={'请输入500字以内说明'} maxLength={500} />}
        orgType={orgType}
      />
      <p className='desc'>{values.organizationAbstract.length}/500</p>
      <FieldX
        required={true}
        name={`baseInfo.${idx}.${OrgKs.responsibilityExplanation}`}
        as={<Input.Textarea placeholder={'请简要描述申报机构在项目中的职责；若有联合申报机构，请分别描述各机构承担的项目职责和分工'} maxLength={100} />}
        orgType={orgType}
      />
      <p className='desc'>{values.responsibilityExplanation.length}/100</p>
      <br />
    </OrgDiv>
  );
};
